import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BranchSelectionModule } from 'src/app/components/branches/branch-selection/branch-selection.module';
import { SkippedConfirmationRoutingModule } from './skipped-confirmation-routing.module';
import { SkippedConfirmationComponent } from './skipped-confirmation.component';

@NgModule({
  declarations: [SkippedConfirmationComponent],
  imports: [
    CommonModule,
    SkippedConfirmationRoutingModule,
    BranchSelectionModule,
  ],
})
export class SkippedConfirmationModule {}
